const csrfCookieKey = '_csrf';

export default {
    app: {
        name: 'tidal-login-web',
        shortName: 'TIDAL',
        tagline: 'High Fidelity Music Streaming',
        description: 'TIDAL is the first global music streaming service with high fidelity sound, hi-def video quality, along with expertly curated playlists and original content — making it a trusted source for music and culture.',
    },
    APP_DIRECTORY: 'app/',
    DEFAULT_LOCALE: 'en',
    ENV_DIRECTORY: 'environment/',
    ENVIRONMENT: /** @type {Tidal.Environment } */ (process.env.DOTENV),
    IS_DEVELOPMENT: process.env.DOTENV === 'development',
    IS_PRODUCTION: process.env.DOTENV === 'production',
    IS_BUILDING: process.env.IS_BUILDING === 'true',
    CSRF_COOKIE_KEY: csrfCookieKey,
    CSRF_COOKIE_NAME: `${csrfCookieKey}-token`,
};
